import React, { Component } from 'react';
import { request } from './../../../../config';
import { translate } from 'react-i18next';
import Loading from './../../Loading/Loading';

class Overdraft extends Component {
    state = {
        isLoading: false,
        item: null
    }

    componentDidMount() {
        this.setState({ isLoading: true });
        let requestBody = {
            token: localStorage.getItem('token'),
            lang: localStorage.getItem('i18nextLng').toUpperCase()
        }
        fetch(request("loan/getOverDraftInformationJuridical", requestBody))
            .then(res => res.text())
            .then((responseJSON) => {
                const JSON = require('true-json-bigint');
                let response = JSON.parse(responseJSON);
                if (response.status.statusCode !== 1 && response.status.statusCode !== 139) {
                    if (response.status.statusCode === 200) {
                        this.props.logout();
                    } else {
                        this.props.alertState(true, 'error', this.props.t('an error occurred'), this.props.t(response.status.statusCode));
                        this.setState({ isLoading: false });
                    }
                }
                else {
                    response.overdraft ?
                        this.setState({ item: response.overdraft, isLoading: false }) :
                        this.props.alertState(true, 'warning', this.props.t('463'), null, null, true);
                }
            },
                (error) => {
                    this.props.history.push("/technical-break");
                });
    }

    render() {
        let { item, isLoading } = this.state;
        let { t } = this.props;

        return (
            <>
                <div className="dashboard-header-route">
                    <div className="dashboard-header-route-left">
                        <button onClick={() => this.props.history.goBack()}>
                            <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M11.7344 21.2188L12.6719 20.3281C12.9062 20.0938 12.9062 19.7188 12.6719 19.5312L5.40625 12.2188H21.4375C21.7188 12.2188 22 11.9844 22 11.6562V10.3438C22 10.0625 21.7188 9.78125 21.4375 9.78125H5.40625L12.6719 2.51562C12.9062 2.32812 12.9062 1.95312 12.6719 1.71875L11.7344 0.828125C11.5469 0.59375 11.1719 0.59375 10.9375 0.828125L1.14062 10.625C0.90625 10.8594 0.90625 11.1875 1.14062 11.4219L10.9375 21.2188C11.1719 21.4531 11.5469 21.4531 11.7344 21.2188Z" fill="#2E3131" />
                            </svg>
                        </button>
                        <h2>{t('Overdraft credit line')}</h2>
                    </div>
                </div>
                <div className="dashboard-container-main-section">
                    {
                        isLoading ?
                            <Loading />
                            :
                            <div className="dashboard-finance-section-cards-section">
                                <div className="dashboard-finance-section-overdraft-section">
                                    <div className="col-12">
                                        <h4>{t('Main information')}</h4>
                                    </div>
                                    <div className='col-12 col-md-6 col-lg-4 col-xl-3'>
                                        <div className="dashboard-finance-section-overdraft-section-box">
                                            <span>{t('Overdraft amount')}</span>
                                            <h6>{item?.approvedOverdraftAmount ?? "--"}</h6>
                                        </div>
                                    </div>
                                    <div className='col-12 col-md-6 col-lg-4 col-xl-3'>
                                        <div className="dashboard-finance-section-overdraft-section-box">
                                            <span>{t('currency')}</span>
                                            <h6>{item?.currency ?? "--"}</h6>
                                        </div>
                                    </div>
                                    <div className='col-12 col-md-6 col-lg-4 col-xl-3'>
                                        <div className="dashboard-finance-section-overdraft-section-box">
                                            <span>{t('Overdraft period')}</span>
                                            <h6>{item?.overdraftPeriodMonths ?? "--"}</h6>
                                        </div>
                                    </div>
                                    <div className='col-12 col-md-6 col-lg-4 col-xl-3'>
                                        <div className="dashboard-finance-section-overdraft-section-box">
                                            <span>{t('Overdraft opening date')}</span>
                                            <h6>{item?.overdraftStartDate ?? "--"}</h6>
                                        </div>
                                    </div>
                                    <div className='col-12 col-md-6 col-lg-4 col-xl-3'>
                                        <div className="dashboard-finance-section-overdraft-section-box">
                                            <span>{t('Overdraft expiry date')}</span>
                                            <h6>{item?.overdraftEndDate ?? "--"}</h6>
                                        </div>
                                    </div>
                                    <div className='col-12 col-md-6 col-lg-4 col-xl-3'>
                                        <div className="dashboard-finance-section-overdraft-section-box">
                                            <span>{t('Number of active transactions')}</span>
                                            <h6>{item?.operationCount ?? "--"}</h6>
                                        </div>
                                    </div>
                                    <div className='col-12 col-md-6 col-lg-4 col-xl-3'>
                                        <div className="dashboard-finance-section-overdraft-section-box">
                                            <span>{t('Transaction activation date')}</span>
                                            <h6>{item?.activationDate ?? "--"}</h6>
                                        </div>
                                    </div>
                                    <div className='col-12 col-md-6 col-lg-4 col-xl-3'>
                                        <div className="dashboard-finance-section-overdraft-section-box">
                                            <span>{t('Linked current account')}</span>
                                            <h6>{item?.linkedAccount ?? "--"}</h6>
                                        </div>
                                    </div>
                                </div>
                                <div className="dashboard-finance-section-overdraft-section">
                                    <div className="col-12">
                                        <h4>{t('Overdraft limit')}</h4>
                                    </div>
                                    <div className='col-12 col-md-6 col-lg-4 col-xl-3'>
                                        <div className="dashboard-finance-section-overdraft-section-box">
                                            <span>{t('Current overdraft limit')}</span>
                                            <h6>{item?.currentOverdraftLimit ?? "--"}</h6>
                                        </div>
                                    </div>
                                    <div className='col-12 col-md-6 col-lg-4 col-xl-3'>
                                        <div className="dashboard-finance-section-overdraft-section-box">
                                            <span>{t('Remaining limit')}</span>
                                            <h6>{item?.limitAmount ?? "--"}</h6>
                                        </div>
                                    </div>
                                    <div className='col-12 col-md-6 col-lg-4 col-xl-3'>
                                        <div className="dashboard-finance-section-overdraft-section-box">
                                            <span>{t('Limit period')}</span>
                                            <h6>{item?.limitPeriodMonths ?? "--"}</h6>
                                        </div>
                                    </div>
                                    <div className='col-12 col-md-6 col-lg-4 col-xl-3'>
                                        <div className="dashboard-finance-section-overdraft-section-box">
                                            <span>{t('Limit opening date')}</span>
                                            <h6>{item?.limitStartDate ?? "--"}</h6>
                                        </div>
                                    </div>
                                    <div className='col-12 col-md-6 col-lg-4 col-xl-3'>
                                        <div className="dashboard-finance-section-overdraft-section-box">
                                            <span>{t('Limit expiry date')}</span>
                                            <h6>{item?.limitEndDate ?? "--"}</h6>
                                        </div>
                                    </div>
                                </div>
                                <div className="dashboard-finance-section-overdraft-section">
                                    <div className="col-12">
                                        <h4>{t('Interest and debt')}</h4>
                                    </div>
                                    <div className='col-12 col-md-6 col-lg-4 col-xl-3'>
                                        <div className="dashboard-finance-section-overdraft-section-box">
                                            <span>{t('Interest rate')}</span>
                                            <h6>{item?.interestRate ?? "--"}</h6>
                                        </div>
                                    </div>
                                    <div className='col-12 col-md-6 col-lg-4 col-xl-3'>
                                        <div className="dashboard-finance-section-overdraft-section-box">
                                            <span>{t('Principal debt')}</span>
                                            <h6>{item?.principalDebt ?? "--"}</h6>
                                        </div>
                                    </div>
                                    <div className='col-12 col-md-6 col-lg-4 col-xl-3'>
                                        <div className="dashboard-finance-section-overdraft-section-box">
                                            <span>{t('Interest debt')}</span>
                                            <h6>{item?.interestDebt ?? "--"}</h6>
                                        </div>
                                    </div>
                                    <div className='col-12 col-md-6 col-lg-4 col-xl-3'>
                                        <div className="dashboard-finance-section-overdraft-section-box">
                                            <span>{t('Penalty')}</span>
                                            <h6>{item?.penaltyAmount ?? "--"}</h6>
                                        </div>
                                    </div>
                                    <div className='col-12 col-md-6 col-lg-4 col-xl-3'>
                                        <div className="dashboard-finance-section-overdraft-section-box">
                                            <span>{t('Total debt')}</span>
                                            <h6>{item?.totalDebt ?? "--"}</h6>
                                        </div>
                                    </div>
                                </div>
                            </div>
                    }
                </div>
            </>
        )
    }
}

export default translate("translation")(Overdraft);